import { AxiosError, AxiosResponse } from "axios";

import { PROJECTS_API_ENDPOINTS } from "@/features/portfolio/api/endpoints";
import { CloneModel } from "@/features/portfolio/models/cloneModel";
import { Project } from "@/features/portfolio/models/portfolioModel";
import apiRequests from "@/shared/config/axiosConfig";

export default async function cloneProject(projectToClone: CloneModel): Promise<Project> {
  try {
    const url = PROJECTS_API_ENDPOINTS.POST_CLONE_PROJECT;

    const response: AxiosResponse<Project> = await apiRequests.post(url, projectToClone);
    const { data, status } = response;

    if (status >= 200 && status < 300) {
      return data;
    }

    // Handle specific error cases here
    switch (status) {
      case 400:
        throw new Error("Bad Request");
      case 401:
        throw new Error("Unauthorized");
      case 404:
        throw new Error("Not Found");
      default:
        throw new Error(`Unknown error occurred with status code ${status}`);
    }
  } catch (e) {
    // @todo Handle Error Below
    const error = e as AxiosError;
    switch (error.response?.status) {
      case 400:
        throw new Error("400: Bad Request");
      case 401:
        throw new Error("401: Unauthorized");
      case 404:
        throw new Error("404: Not Found");
      default:
        throw new Error(
          `Unknown error occurred with status code ${error.response?.status}`
        );
    }
  }
}
